import { call, select, race, take, delay, put } from "redux-saga/effects";
import { createSelector } from "reselect";
import { ctaLabelSelectorProps } from "@grandvisionhq/configurator";
import { statusSuccess, statusFailed, actions } from "@grandvisionhq/state";
import { LensAddOnStepContainer } from "../../../../../../../../steps/LensAddOnStep/steps/LensAddOnStep/LensAddOnStepContainer.js";
import "../../../../../../../state/actions.js";
import "../../../../../../../add-to-cart/state/add-to-cart/selectors.js";
import "../../../../../../../bundles/state/bundles/selectors.js";
import "../../../../../../../bundles/state/bundles/reducer.js";
import { getSelectedAddOn, getFrameSku, getSelectedPackage, getAddOns, getSelectedLensType } from "../../../../../../state/configurator/selectors.js";
import "../../../../../../state/configurator/reducer.js";
import "../../../../../../../products/state/products/selectors.js";
import "../../../../../../../products/state/products/reducer.js";
import { selectAddOn } from "../../../../../../../configurations/state/configurations/actions.js";
import { fetchAddOnsSuccess, fetchAddOnsFailed } from "../../../../../../../bundles/state/bundles/actions.js";
const lensAddOnStepBase = {
  *onEnter() {
    yield call(selectDefaultAddOn);
  },
  ctaLabel: createSelector(
    ctaLabelSelectorProps,
    getSelectedAddOn,
    ({ defaultCtaLabel, alternativeCtaLabel }, selectedAddOn) => {
      return Number(selectedAddOn?.variants?.length) > 1 && alternativeCtaLabel ? { key: alternativeCtaLabel } : { key: defaultCtaLabel };
    }
  ),
  view: LensAddOnStepContainer
};
const isSuccess = ({ packageSku }) => (a) => actions.isType(a, fetchAddOnsSuccess) && a.payload.packageSku === packageSku;
const isFailed = ({ packageSku }) => (a) => actions.isType(a, fetchAddOnsFailed) && a.payload.packageSku === packageSku;
function* selectDefaultAddOn() {
  const selectedAddOn = yield select(
    getSelectedAddOn
  );
  if (!selectedAddOn) {
    const frameSku = yield select(getFrameSku);
    if (!frameSku) {
      return;
    }
    const selectedPackage = yield select(
      getSelectedPackage
    );
    let addOns = yield select(getAddOns);
    if (!statusSuccess(addOns) && !statusFailed(addOns)) {
      const lensType = yield select(
        getSelectedLensType
      );
      if (!lensType) {
        return;
      }
      if (!selectedPackage) {
        return;
      }
      const [success] = yield race([
        take(isSuccess({ packageSku: selectedPackage.sku })),
        take(isFailed({ packageSku: selectedPackage.sku })),
        delay(3e4, true)
      ]);
      if (success) {
        addOns = yield select(getAddOns);
      }
    }
    if (statusSuccess(addOns)) {
      const products = addOns.result;
      const variants = products.reduce(
        (acc, p) => [...acc, p, ...p.variants || []],
        []
      );
      let addOnSku = selectedPackage?.areAddOnsOptional ? "" : addOns.result[0]?.sku;
      for (const variant of variants) {
        if (variant.isDefault) {
          addOnSku = variant.sku;
          break;
        }
      }
      if (addOnSku) {
        yield put(
          selectAddOn({
            frameSku,
            addOnSku,
            reason: "default selection"
          })
        );
      }
    }
  }
}
export {
  lensAddOnStepBase,
  selectDefaultAddOn
};
//# sourceMappingURL=lens-add-on.js.map
